<template>
  <!-- <DxButton  icon="refresh" @click="refreshDataGrid" /> -->
  <div class="">
    <h6 v-if="AreIdsShown" style="background: darkred; color: orange">WidgetRecordSelector</h6>
    <h6 v-if="AreIdsShown" style="background: darkblue; color: yellow">selectedFileName {{ selectedFileName }} records {{ records.length }}</h6>

    <h6 v-if="AreIdsShown" style="background: black; color: cyan">recordsSelected {{ recordsSelected }}</h6>

    <slot :recordsSelected="recordsSelected"></slot>

    <h3 v-if="AreIdsShown">WidgetRecordSelector</h3>
    <DxButton v-if="AreIdsShown" icon="refresh" @click="refreshDataGrid" />
    <!-- @cell-click="onCellClick" @row-click="onRowClick" @selection-changed="onSelectionChanged" -->
    <DxDataGrid
      class="widgetSummaryWorkGrid"
      :show-borders="true"
      :data-source="records"
      :selected-row-keys="selected"
      :row-alternation-enabled="true"
      :hover-state-enabled="true"
      width="100%"
      :column-auto-width="true"
      :focused-row-enabled="true"
      :word-wrap-enabled="true"
      ref="dataGridRef"
      :key-expr="idField"
      noDataText="No Records were found ........"
      @cell-prepared="onCellPrepared"
      @row-click="onRowClick"
      @selection-changed="onSelectionChanged"
      @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparing"
      @row-expanding="onRowExpanding"
    >
      <DxLoadPanel :enabled="true" />

      <DxColumn v-if="AreIdsShown" data-field="id" caption="DRS id" />
      <DxColumn v-if="AreIdsShown" data-field="personId" caption="DRS PersonId" />

      <DxColumn data-field="priority" caption="Priority" cell-template="priority-cell" :width="60" />
      <template #priority-cell="{ data }">
        <div class="newStatusHi" style="padding: 0%">
          <div class="justify-content-center align-items-center" style="display: flex; padding: 0%; width: 100%">
            <div>
              <!-- {{ data.text }} -->

              <h6 class="mb-0" v-if="data.text === '0'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em">
                  <!-- Bottom filled circle (info) -->
                  <font-awesome-icon :icon="['fas', 'circle']" size="2x" style="color: #17a2b8; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Bell icon (white, centered) -->
                  <font-awesome-icon :icon="['fas', 'bell']" size="1x" style="color: white; position: absolute; left: 0.45em; top: 0.45em; font-size: 1.2em; z-index: 2" />
                  <!-- Top outline circle (danger) -->
                  <font-awesome-icon :icon="['far', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 3" />
                </span>
              </h6>
              <h6 class="mb-0" v-if="data.text === '1'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em; background: MistyRose; border-radius: 0.5em">
                  <!-- Bottom diamond (filled) -->
                  <font-awesome-icon :icon="['fas', 'diamond']" size="2x" style="color: #ffc107; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Exclamation, centered and larger -->
                  <font-awesome-icon :icon="['fas', 'exclamation']" size="lg" style="color: #dc3545; position: absolute; left: 0.55em; top: 0.25em; font-size: 1.5em; z-index: 2" />
                  <!-- Top diamond (outline, optional for effect) -->
                  <!-- <font-awesome-icon :icon="['fas', 'diamond']" size="2x" style="color: #ffc107; position: absolute; left: 0; top: 0; z-index: 3" /> -->
                </span>
              </h6>
              <h6 class="mb-0" v-if="data.text === '2'">
                <span style="position: relative; display: inline-block; width: 2em; height: 2em">
                  <!-- Bottom filled circle (danger) -->
                  <font-awesome-icon :icon="['fas', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 1" />
                  <!-- Exclamation circle (white, centered) -->
                  <font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" style="color: white; position: absolute; left: 0.17em; top: 0.25em; font-size: 1.5em; z-index: 2" />
                  <!-- Top outline circle (danger) -->
                  <font-awesome-icon :icon="['far', 'circle']" size="2x" style="color: #dc3545; position: absolute; left: 0; top: 0; z-index: 3" />
                </span>
              </h6>
            </div>
          </div>
        </div>
      </template>

      <DxColumn data-field="dueText" caption="DUE" cell-template="dueText" />
      <template #dueText="{ data }">
        <!-- <span v-if="data.data.dueText === 'Overdue'" style="background: #8a11118a; color: #e0f2e1">{{ data.data.dueText }}</span> -->
        <!-- <span v-else style="background: #9aa99b; color: #e3f4e5">{{ data.data.dueText }}</span> -->
        <span>{{ data.data.dueText }}</span>
      </template>
      <DxColumn data-field="lastName" caption="Last Name" cell-template="lastName" />
      <template #lastName="{ data }">
        <!-- {{ data.text }} -->
        <!-- <router-link :to="`/Patient/${data.data.personId}`">{{ data.data.lastName }}</router-link> -->
        <b-nav pills>
          <b-nav-item :to="`/emr/Patient/${data.data.personId}`">{{ data.data.lastName }}</b-nav-item>
        </b-nav>
      </template>

      <DxColumn data-field="firstName" caption="First Name" cell-template="firstName" />
      <template #firstName="{ data }">
        <!-- {{ data.text }} -->
        <!-- <router-link :to="`/Patient/${data.data.personId}`">{{ data.data.firstName }}</router-link> -->
        <b-nav pills>
          <b-nav-item :to="`/emr/Patient/${data.data.personId}`">{{ data.data.firstName }}</b-nav-item>
        </b-nav>
      </template>



      <DxColumn data-field="middleName" caption="Middle" />
      <DxColumn data-field="dateOfBirth" caption="DOB" cell-template="formatDate-template" />
      <DxColumn data-field="lastSeen" caption="Last Seen" cell-template="formatDate-template" />
      <DxColumn data-field="lastSeenBy" caption="Last Seen by" />
      <DxColumn data-field="nextAppointment" caption="Next Appointment" sort-order="desc" cell-template="formatDate-template" />
      <DxColumn data-field="taskCount" alignment="left" caption="Task Count" />

      <DxExport :enabled="true" />
      <DxSearchPanel :visible="true" />

      <DxPaging :enabled="true" :pageSize="50" />

      <!-- <DxSearchPanel :visible="false" />
      <DxHeaderFilter :visible="false" />
      <DxFilterRow :visible="false" /> -->

      <!-- <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" /> -->
      <DxSelection :select-all-mode="allMode" :show-check-boxes-mode="checkBoxesMode" mode="multiple" />
      <template #formatDate-template="{ data }">
        <span>{{ useFormatDate(data.text) }}</span>
      </template>
      <DxMasterDetail :enabled="true" template="details" :auto-expand-all="false" />
      <template #details="{ data }">
        <!-- <h3>MyWorkDetails :getRecords="fetchMyWorkDetails" :id="currentPersonId"</h3>
        :workDetails="getSomeStuff(currentPersonId)" -->
        <!-- <button @click="getSomeStuff(currentPersonId)"> FETCH DETAILS by ID       {{ currentPersonId }}</button> -->
        <MyWorkDetails :dataRow="data.data" @postTaskStatusRefresh="emitToParent" />
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { DxDataGrid, DxLoadPanel, DxColumn, DxPaging, DxFilterRow, DxHeaderFilter, DxMasterDetail, DxSelection, DxExport, DxSearchPanel, DxColumnFixing, DxScrolling } from "devextreme-vue/data-grid";
import { DxButton } from "devextreme-vue/button";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import { usePatientStore } from "@/stores/patientStore";
import moment from "moment";

import MyWorkDetails from "./MyWorkDetails.vue";

// ? test
import { customers } from "./WidgetRecordSelectorData.ts";

// import { fetchMyWorkDetails } from "@/api/workListsApi";

// let props1 = defineProps({
//     date: String,
// })
const patientStore = usePatientStore();

// * EMITTER
const emit = defineEmits(["recordsSelectedRows", "recordsSelected", "postTaskStatusRefresh"]);
// & PROPS
const props = defineProps({
  records: {
    type: Array,
    required: true,
    default: () => [],
  },
  fields: {
    type: Array,
    required: false,
    default: () => [],
  },
  idField: {
    type: String,
    required: false,
  },
  selected: {
    type: Array,
    required: false,
  },
  handleOnCellPrepared: {
    type: Function,
    required: false,
  },
  FromLabs: {
    type: Boolean,
    required: false,
  },
  selectedFileName: {
    type: String,
    default: () => {},
  },
});

// ~ string Template TEST
const name = "thomas";
const job = "Window Washer";

const cCatStrings = "Hi my name is " + name + " and I am a " + job;
// * USEs  BACKTICKs
const templateSTRING = `Hi, my name is  is     ${name}`;

// & COMPOSIBLEs
import { useMouse } from "@/use/mouse.js";
import { useFormatDate } from "@/use/formatDate.js";

const { x, y } = useMouse();

const modalTheme = computed(() => userStore.bModalTheme);

// const dateCh = useFormatDate()

const AreIdsShown = ref(false);
const dataGridRef = ref(null);
const currentRowData = ref({});

const userSelectedRecords = ref([]);

let currentPersonId = ref("");

let workDetailRecords = ref([]);

function onCellPrepared(e) {
  // console.clear();
  // console.log("E");
  // console.log(e);
  // console.log(e.column.dataField);

  if (e.column.dataField === "dueText") {
    // console.log("DUE");
    // console.log(e);
    // console.log(e.data?.dueText);

    if (e.column.dataField === "dueText") {
      switch (e.data?.dueText) {
        case "Overdue":
          e.cellElement.style.backgroundColor = "#8a11118a";
          e.cellElement.style.color = "#e0f2e1";
          e.cellElement.style.fontWeight = "bold";
          e.cellElement.style.fontSize = "1.0rem"; // or "20px" or any size you want
          e.cellElement.style.width = "100%";
          e.cellElement.style.display = "flex";
          e.cellElement.style.alignItems = "center";
          e.cellElement.style.justifyContent = "center";
          e.cellElement.style.textAlign = "center";
          e.cellElement.style.height = "100%";
          e.cellElement.style.textTransform = "uppercase";
          break;
        case "Next 7 Days":
          e.cellElement.style.backgroundColor = "#4caf50"; // "#b7e18a8a";
          // e.cellElement.style.color = "#222";
          break;
        case "Next 8-14 Days":
          // Even lighter red
          e.cellElement.style.backgroundColor = "#ffca45"; // "#e1b84d8a";
          e.cellElement.style.color = "#222";
          break;
        case "Next 15-30 Days":
          // Orange-red
          e.cellElement.style.backgroundColor = "#e1b84d8a";
          // e.cellElement.style.color = "#ff6a45";
          break;
        case "Next 31-90 Days":
          // Yellow-orange
          e.cellElement.style.backgroundColor = "#d17a4d8a";
          // e.cellElement.style.color = "#222";
          break;
        case "Over 90 to EOY":
          // Light yellow-green
          e.cellElement.style.backgroundColor = "transparent";
          // e.cellElement.style.color = "#222";
          break;

        case "Completed":
          e.cellElement.style.backgroundColor = "#4caf50";
          e.cellElement.style.color = "#fff";
          break;
        default:
          // e.cellElement.style.backgroundColor = "#9aa99b";
          // e.cellElement.style.color = "#e3f4e5";
          break;
      }
    }
  }

  if (!props.handleOnCellPrepared) return;
  props.handleOnCellPrepared(e);

  // console.log(props.handleOnCellPrepared(e));
}
function onExporting(e) {
  // console.clear();
  // console.log(e);
  // console.log(e.fileName);
  // * NEW FILENAME BINDING
  e.fileName = props.selectedFileName;
  // console.log(e.fileName);

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet("Main sheet");
  exportDataGrid({
    component: e.component,
    worksheet: worksheet,
    customizeCell: function (options) {
      options.excelCell.font = { name: "Arial", size: 12 };
      options.excelCell.alignment = { horizontal: "left" };
    },
  }).then(function () {
    // console.log(" 												  ... saveAS");

    workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], { type: "application/octet-stream" }), e.fileName + ".xlsx");
    });
  });
}
function onToolbarPreparing(e) {
  var item = e.toolbarOptions.items.find((item) => item.name === "exportButton");

  if (item) {
    // Check if 'item' was found
    item.showText = "always";
  } else {
    console.warn("Toolbar item with name 'exportButton' not found.");
    // Optionally handle the case where the item is not found,
    // e.g., add the item if it's missing or log a warning.
  }

  const toolbarItems = e.toolbarOptions.items;

  // Iterate over the toolbar items and change the location
  toolbarItems.forEach((item) => {
    if (item.name === "searchPanel" || item.name === "exportButton") {
      item.location = "before";
    }
  });
}
async function onRowExpanding(e) {
  // //console.clear()()
  // console.log("   	   	endOf												DASH   REC SELECTOR  onRowExpanding :  collapseAll");
  e.component.collapseAll(-1);

  // console.log("E: ");
  // console.dir(e);
  // console.dir(e.component.currentPersonId);
  // console.dir(e.row.data);

  //console.log('this.currentPersonId  ')
  //console.log(this.currentPersonId)
  // console.log(">>>>>>>>>>>>>>>>>>>>>>>> SETS current Persion ID   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

  currentPersonId.value = e.component.currentPersonId;
  // console.log("currentPersonId ");
  // console.log(currentPersonId.value);
  // console.log("((((((((");
  // todo test

  // onCellClick(e);
}
function onSelectionChanged(e) {
  // console.log("                               onSelectionChanged  TEST #1");
  // console.dir(e);
  // console.log("									DASH REC SELECT: 	onSelectionChanged(e)");
  e.component.collapseAll(-1);
  e.component.expandRow(e.currentSelectedRowKeys[0]);

  // console.log(e.selectedRowsData);

  userSelectedRecords.value = e.selectedRowsData;

  // console.log("     >>>>>>>>>>>         userSelectedRecords.value");
  // console.log(userSelectedRecords.value);

  // console.log("****************************************************");
  // console.log("		***			>>>>>>>>>>>>>>>>>>    STORE  		  													setCurrentPatient	 this.currentTask");

  // console.log(" WidRecSel   TODO  build EMIITERs / test ");
  //   //! EMITTER :  ROW W/   RECORD OBJ
  //   this.$emit(    "recordsSelectedRows",    this.recordsSelected.map((record) => record)  );
  emit(
    "recordsSelectedRows",
    userSelectedRecords.value.map((record) => record)
  );

  //   //? EMITTER :  Map: rec => rec[idField]
  //   this.$emit(    "recordsSelected",    this.recordsSelected.map((record) => record.personId)  );
  emit(
    "recordsSelected",
    userSelectedRecords.value.map((record) => record.personId)
  );
}

function onCellClick(e) {
  // console.clear();
  // console.log("****************************************************");
  // console.log("	    WIDGET RECORD  Selector													onCellClick (e)   			this.currentTask = e.row.data ");

  // console.log(" E: ");
  // console.dir(e);
  // console.log("****************************************************");

  if (e.row !== undefined) {
    // if (e.row.isSelected) {
    //   //console.log('CLEARING SELECTION *************************')
    //   e.component.clearSelection();
    // }
    // ////console.dir(e)

    currentRowData.value = e.row.data;
    // console.log("currentRowData.value");
    // console.dir(currentRowData.value);

    // console.log("****************************************************");
    // console.log("		***			>>>>>>>>>>>>>>>>>>    STORE  		  													setCurrentPatient	 this.currentTask");

    patientStore.setCurrentPatient(currentRowData.value);

    // const cPerson = e.row.data.personId;
    //console.log('		e.row.data.personId   = 	cPerson', cPerson)
    //   this.$store.commit("setCurrentPatient", this.currentTask);

    //console.log(this.currentTask.personId)
    currentPersonId.value = currentRowData.value.personId;
    // console.log("currentPersonId.value");
    // console.log(currentPersonId.value);

    //console.log('			this.currentPersonId', this.currentPersonId)

    //console.log('****************************************************')
    //console.log(				'		***			>>>>>>>>>>>>>>>>>>    STORE  		setPatientId	 this.currentPersonId'			)

    // console.log('		OFF  this.$store.commit("setPatientId", this.currentTask.personId);  ****************************************************');
    //   this.$store.commit("setPatientId", this.currentTask.personId);

    // console.log("****************************************************");
    // //console.log('	NEW >>>   getPatientChartDATA ..')
    // this.getPatientChartDATA()
    // console.log("		OFF  this.checkForSingleTask();   ****************************************************");
    //   this.checkForSingleTask();
  }
}

function onRowClick(e) {
  // console.clear();
  // console.log("****************************************************");
  // console.log("	    WIDGET RECORD  Selector													onRowClick (e) ");

  // console.log(" E: ");
  // console.dir(e);

  // console.log("****  ************************************************");

  if (e.data !== undefined) {
    // if (e.row.isSelected) {
    //   //console.log('CLEARING SELECTION *************************')
    //   e.component.clearSelection();
    // }
    // ////console.dir(e)

    // console.log(" E: data ");
    // console.dir(e.data);

    currentRowData.value = e.data;
    // console.log("currentRowData.value");
    // console.dir(currentRowData.value);

    // console.log("****************************************************");
    // console.log("		***			>>>>>>>>>>>>>>>>>>    STORE  		  													setCurrentPatient	 this.currentTask");

    patientStore.setCurrentPatient(currentRowData.value);

    // const cPerson = e.row.data.personId;
    //console.log('		e.row.data.personId   = 	cPerson', cPerson)
    //   this.$store.commit("setCurrentPatient", this.currentTask);

    //console.log(this.currentTask.personId)
    currentPersonId.value = currentRowData.value.personId;
    // console.log("currentPersonId.value");
    // console.log(currentPersonId.value);
  }
}
function emitToParent() {
  // console.log("emitToParent() :     								  Widget Record Selector  >>>>");

  emit("postTaskStatusRefresh", true);
  // console.log("EMITTing  from WidgetRecSelect ", true);
}
function refreshDataGrid() {
  // console.clear();
  // console.log("              refreshDataGrid");
  // const dataGrid = dataGridRefKey.instance;
  const dataGrid = dataGridRef.value.instance;
  // console.log("                                         dataGrid");
  // console.log(dataGrid);
  dataGrid
    .refresh()
    .then(function () {
      // ...
      // console.log(" grid refresh");
      const dSource = dataGrid.getDataSource().items();
      // console.log(" grid : DATASOURCE");
      // console.log(dSource);
      // console.log(" dataGrid.getVisibleRows() ");
      // console.log(dataGrid.getVisibleRows());
      // console.log(" dataGrid.getSelectedRowsData() ");
      // console.log(dataGrid.getSelectedRowsData());
    })
    .catch(function (error) {
      // console.log("ERROR >>>>");
      // console.log(error);
    });
}

onMounted(() => {
  //   console.clear();
  // console.log("onMounted() :     								  Widget Record Selector  >>>>");
  // console.log(" prop   records ");
  // console.log("props : ");
  // console.log(props);
  // console.log({ ...props.records });
});
</script>

<style lang="scss" scoped>
.page-grid-wrapperDash {
  background: darkkhaki;
  padding: 6px;
  overflow: auto;
}

.detailsSlot {
  background: transparent; // #007f8b !important;
  padding: 0px;
}

a {
  text-decoration: none;
  font-weight: bolder;
  // color: #83ff7d;
  //background:#dcf1de;
}

// .DxSelection td {
// 	background: rgb(227, 255, 17) !important;
// }
// .dx-row-focused.dx-data-row > td:not(.dx-focused),
//.dx-row-focused.dx-data-row > tr > td:not(.dx-focused) ,
//.dx-row-focused.dx-data-row>tr>td>a:not(.dx-focused) {
//background-color: #e59807; //95c6ef
//color: rgb(255, 251, 9);
//}

// .dx-datagrid-rowsview
// 	.dx-row-focused.dx-data-row
// 	.dx-command-edit:not(.dx-focused)
// 	.dx-link,
// .dx-datagrid-rowsview .dx-row-focused.dx-data-row > td:not(.dx-focused),
// .dx-datagrid-rowsview .dx-row-focused.dx-data-row > tr > td:not(.dx-focused) {
// 	background-color: #bcb91a;
// 	color: rgb(151, 27, 176);
// }
a.nav-link {
  display: block;
  // background-color: #bcb91a;
  padding: 0%;
  // PRORITY ICON   AREA   background: darkblue;
}
#grid-container {
  height: 440px;
  background: #f3ff4589;
}
</style>
